import React from 'react';
import classes from './styles/detailsPlaceholder.module.css';

const DetailsPlaceHolder = () => {
  return (
    <div className={classes.placeholder}>
      <div className={classes.upperCon}>
        <div className={classes.titleCon}> 
            <p className={classes.glow}>
                <span className={classes.heading}></span><br />
                <span className={classes.date}></span><br />
                <span className={classes.date}></span><br />
                <span className={classes.date}></span><br />
            </p>
        </div> 
        <div className={classes.btnCon}>
            <p className={classes.glow}>
                <span className={classes.btn}></span>
            </p>
        </div>
      </div>
      <div className={classes.desCon}>
        <p className={classes.glow}>
                <span className={classes.description1}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description3}></span><br />
                <span className={classes.description4}></span><br /><br />

                <span className={classes.description1}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description3}></span><br />
                <span className={classes.description4}></span><br /><br />


                <span className={classes.description1}></span><br />
                <span className={classes.description3}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description3}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description4}></span><br /><br />


                <span className={classes.description1}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description3}></span><br />
                <span className={classes.description4}></span><br /><br />

                <span className={classes.description1}></span><br />
                <span className={classes.description2}></span><br />
                <span className={classes.description3}></span><br />
                <span className={classes.description4}></span><br />
            </p>
      </div>
    </div>
  );
};

export default DetailsPlaceHolder;
